import { Suspense, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { LoadingScreen } from "./components/LoadingScreen";
import { PortalLayout } from "./components/PortalLayout";
import { api } from "./lib/api";

function PortalPageOutlet() {
  const location = useLocation();
  return (
    <Suspense fallback={<LoadingScreen message="Loading page…" />}>
      <Outlet key={location.pathname} />
    </Suspense>
  );
}

export function AdminPortalGuard() {
  const [ok, setOk] = useState<boolean | null>(null);
  const [name, setName] = useState("Admin");
  const [dept, setDept] = useState("Administration");

  useEffect(() => {
    void api.admin.me().then((res) => {
      setOk(!!res.success);
      if (res.success && res.data) {
        const profile = res.data as { name: string; department?: { name: string } };
        setName(profile.name);
        if (profile.department?.name) setDept(profile.department.name);
      }
    });
  }, []);

  if (ok === null) return <LoadingScreen message="Checking session…" />;
  if (!ok) return <Navigate to="/" replace />;
  return (
    <PortalLayout variant="admin" userName={name} subtitle={dept}>
      <PortalPageOutlet />
    </PortalLayout>
  );
}

export function StaffPortalGuard() {
  const [ok, setOk] = useState<boolean | null>(null);
  const [name, setName] = useState("Staff");
  const [dept, setDept] = useState("");
  const [trackingPending, setTrackingPending] = useState(false);

  useEffect(() => {
    void api.staff.me().then((res) => {
      setOk(!!res.success);
      if (res.success && res.data) {
        const d = res.data as {
          name: string;
          department: { name: string };
          trackingEnabled?: boolean;
          timezone?: string | null;
        };
        setName(d.name);
        setDept(d.department.name);
        setTrackingPending(d.trackingEnabled === false);

        const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (browserTz && d.timezone !== browserTz) {
          void api.staff.updateTimezone(browserTz);
        }
      }
    });
  }, []);

  if (ok === null) return <LoadingScreen message="Checking session…" />;
  if (!ok) return <Navigate to="/" replace />;
  return (
    <PortalLayout variant="staff" userName={name} subtitle={dept} trackingPending={trackingPending}>
      <PortalPageOutlet />
    </PortalLayout>
  );
}
